import { Download, Share, PlusSquare, CheckCircle2, MoreVertical } from "lucide-react";
import { toast } from "sonner";
import { useInstall } from "@/lib/pwa";

function Step({ n, children }) {
  return (
    <li className="flex items-center gap-3 text-sm text-[#D4D4D8]">
      <span className="w-6 h-6 shrink-0 rounded-full bg-[#222225] text-xs font-bold flex items-center justify-center">{n}</span>
      <span className="flex items-center gap-1.5 flex-wrap">{children}</span>
    </li>
  );
}

export function InstallCard({ compact = false }) {
  const { installed, canPrompt, ios, android, promptInstall } = useInstall();

  if (installed) {
    return (
      <div data-testid="install-installed" className="card p-4 flex items-center gap-3">
        <CheckCircle2 className="text-[#10B981]" size={22} />
        <div className="text-sm">Roll SmartR is installed on this device.</div>
      </div>
    );
  }

  const onInstall = async () => {
    const ok = await promptInstall();
    if (ok) toast.success("Roll SmartR installed");
  };

  return (
    <div data-testid="install-card" className="card p-5">
      {!compact && (
        <div className="flex items-center gap-3 mb-4">
          <img src="/icon-192.png" alt="Roll SmartR icon" className="w-12 h-12 rounded-xl" />
          <div>
            <div className="font-semibold">Add Roll SmartR to your phone</div>
            <div className="text-xs text-[#A1A1AA]">Opens full-screen like a real app. Log from the mat in seconds.</div>
          </div>
        </div>
      )}
      {canPrompt ? (
        <button data-testid="install-app-button" onClick={onInstall} className="btn-primary">
          <Download size={18} /> Install app
        </button>
      ) : ios ? (
        <ol className="space-y-3" data-testid="install-ios-steps">
          <Step n={1}>Tap <Share size={15} className="text-[#3B82F6]" /> <b>Share</b> in Safari</Step>
          <Step n={2}>Choose <PlusSquare size={15} /> <b>Add to Home Screen</b></Step>
          <Step n={3}>Tap <b>Add</b></Step>
        </ol>
      ) : android ? (
        <ol className="space-y-3" data-testid="install-android-steps">
          <Step n={1}>Tap the <MoreVertical size={15} /> menu in Chrome</Step>
          <Step n={2}>Choose <b>Install app</b> or <b>Add to Home screen</b></Step>
          <Step n={3}>Tap <b>Install</b></Step>
        </ol>
      ) : (
        <ol className="space-y-3" data-testid="install-desktop-steps">
          <Step n={1}>Open this page on your phone</Step>
          <Step n={2}>iPhone: Safari <Share size={15} className="text-[#3B82F6]" /> Share, then <b>Add to Home Screen</b></Step>
          <Step n={3}>Android: Chrome <MoreVertical size={15} /> menu, then <b>Install app</b></Step>
        </ol>
      )}
    </div>
  );
}
